<template>
  <!-- The environment bar belongs to the whole app, not just the signed-in
       shell, so it lives here rather than in AppLayoutView: login is exactly
       where knowing which environment you are about to sign in to matters.
       The column owns the viewport height and AppLayoutView fills what is
       left, which is why that view is h-full and not h-dvh. -->
  <div class="flex h-dvh flex-col">
    <EnvBar />
    <div class="relative min-h-0 flex-1 overflow-auto">
      <router-view />
      <div
        v-if="!currentUser"
        class="absolute top-2 right-3">
        <LangSelect />
      </div>
    </div>
  </div>
  <ModalHost />
  <!-- @click.stop prevents toast clicks from reaching the window-level click listener in SidePane -->
  <Teleport to="body">
    <div @click.stop>
      <Toaster
        position="bottom-left"
        :visibleToasts="5"
        :duration="5000"
        closeButton
        closeButtonPosition="top-right"
        expand />
    </div>
  </Teleport>
</template>

<script lang="ts">
import { Toaster } from 'vue-sonner'
import { hasUnsavedChanges } from '@/composables/useUnsavedChangesGuard'
import { useUserStore } from '@/stores/userStore'
import { mapState } from 'pinia'

export default {
  name: 'App',
  components: { Toaster },
  computed: {
    ...mapState(useUserStore, ['currentUser']),
  },
  methods: {
    // The tab-close / reload half of the unsaved-changes guard. In-app
    // navigation is handled by the router guard in router/index.ts; this
    // covers the one departure the router never sees.
    onBeforeUnload(e: BeforeUnloadEvent) {
      if (!hasUnsavedChanges()) return
      e.preventDefault()
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.onBeforeUnload)
  },
  beforeUnmount() {
    window.removeEventListener('beforeunload', this.onBeforeUnload as EventListener)
  },
}
</script>

